
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '../auth/AuthContext';
import { lazy, Suspense } from 'react';
import AuthGuard from '../auth/AuthGuard';
import ResetPassword from '../Componenets/ResetPassword';
import { SidebarProvider } from '../Componenets/Portals/Sidebar/SidebarContext';
import Portal from '../Componenets/Portals/portal';
import { UnsavedChangesProvider } from '../Componenets/Portals/Context/UnSavedChangesContext';
import VendorDashboard from '../Componenets/VendorDashboard/VendorDashboard';
function RouterApp() {
const LoginForm = lazy(() => import('../Componenets/login/Login'));
const ForgotPassword = lazy(() => import('../Componenets/login/ForgotPassword'));
// const AuthGuard = lazy(() => import('../auth/AuthGuard'));
  return (
    <div>
      
    <Router>
    <UnsavedChangesProvider>
    <SidebarProvider>
    <AuthProvider>
     <Suspense fallback={null}>
 <Routes>
 
   <Route path="/" element={<Navigate to="/login" />} />
   <Route path="/login" element={<LoginForm />} />
   <Route path='/changePassword' element={<ForgotPassword />} />
   <Route path='/forgot-password' element={<ResetPassword />} />
   <Route path="/portals/*" element={<AuthGuard><Portal /></AuthGuard>} />
   <Route path="/vendorDashboard/*" element={<AuthGuard><VendorDashboard /></AuthGuard>} />
  
   {/* <Route path="/portals/*" element={<Portal />} /> */}
   
 </Routes>
 </Suspense>
 </AuthProvider>
 </SidebarProvider>
</UnsavedChangesProvider>
</Router>

 </div>
  )
}

export default RouterApp
